"use client"

import * as React from "react"
import { Calendar as CalendarIcon } from "lucide-react"
import { format } from "date-fns"
import { DateRange, DayPicker } from "react-day-picker" // Correct import

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"

interface DateRangePickerProps extends React.HTMLAttributes<HTMLDivElement> {
  date: DateRange | undefined
  onDateChange: (date: DateRange | undefined) => void
}

const DateRangePicker = React.forwardRef<HTMLDivElement, DateRangePickerProps>(
  ({ className, date, onDateChange, ...props }, ref) => {
    return (
      <div className={cn("grid gap-2", className)} ref={ref} {...props}>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant={"outline"}
              className={cn(
                "w-full min-w-[280px] justify-start text-left font-normal", // Adjusted width for responsiveness
                !date && "text-muted-foreground"
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {date?.from ? (
                date.to ? (
                  `${format(date.from, "PPP")} - ${format(date.to, "PPP")}`
                ) : (
                  format(date.from, "PPP")
                )
              ) : (
                <span>Pick a date range</span> // Changed placeholder text
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start"> {/* Changed align */}
            {/* Changed usage from Calendar to DayPicker */}
            <DayPicker
              mode="range"
              defaultMonth={date?.from}
              selected={date}
              onSelect={onDateChange}
              numberOfMonths={2}
            />
          </PopoverContent>
        </Popover>
      </div>
    )
  }
)
DateRangePicker.displayName = "DateRangePicker"

export { DateRangePicker }
